import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { FC_AMBIGUOUS_LAST4_COPY } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

/** "Yes, link this account" or "Choose a different account"; null is Cancel, the X or Escape. */
export type FcAmbiguousAccountAnswer = 'confirm' | 'choose-another';

export interface FcAmbiguousAccountDialogInput {
    /** Core's refusal, which names both accounts, or the fallback copy. Plain text. */
    message: string;
}

/**
 * SD-10387: core cannot tell two of the org's accounts apart by last4, so the admin says whether the
 * account picked at the bank is this row. Asked through `FcAmbiguousAccountDialogStateService`.
 */
@Component({
    selector: 'app-fc-ambiguous-account-dialog',
    standalone: true,
    templateUrl: './fc-ambiguous-account-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FcAmbiguousAccountDialogComponent {
    @Input() open = false;
    @Input() message = '';
    @Output() readonly closed = new EventEmitter<FcAmbiguousAccountAnswer | null>();

    readonly copy = FC_AMBIGUOUS_LAST4_COPY;
}
